export const translations = {
  ru: {
    // Header
    nav: {
      about: "О продукте",
      features: "Возможности",
      investors: "Инвесторам",
      contact: "Контакты",
      preorder: "Предзаказ"
    },
    // Hero
    hero: {
      title: "Невидимая CAREVA",
      titleHighlight: "24/7",
      subtitle: "CAREVA использует mmWave радар для дискретного мониторинга пожилых людей без камер. 100% приватность с встроенной бесплатной 4G связью.",
      btnCustomers: "Для клиентов",
      btnInvestors: "Для инвесторов"
    },
    // Problem/Solution
    comparison: {
      title: "Почему",
      titleHighlight: "CAREVA",
      subtitle: "Сравните наше решение с традиционными методами мониторинга",
      cameras: {
        title: "Камеры",
        item1: "Нарушают приватность",
        item2: "Неудобство для пожилых",
        item3: "Требуют Wi-Fi",
        item4: "Сложная установка"
      },
      careva: {
        title: "CAREVA mmWave",
        item1: "100% приватность - никаких линз",
        item2: "Незаметный мониторинг",
        item3: "Встроенный 4G - независимо от Wi-Fi",
        item4: "Простая установка"
      },
      wearables: {
        title: "Носимые устройства",
        item1: "Нужно носить постоянно",
        item2: "Требуют зарядки",
        item3: "Легко забыть/потерять",
        item4: "Неудобны во время сна"
      }
    },
    // Features
    features: {
      title: "Технологии",
      titleHighlight: "VitalGuard AI",
      feature1: {
        title: "Умный ночник",
        desc: "Автоматическое освещение с датчиками движения для безопасности в темное время суток"
      },
      feature2: {
        title: "Резервная батарея и SIM-слот",
        desc: "Работает до 48 часов без электричества с встроенной 4G связью для экстренных ситуаций"
      },
      feature3: {
        title: "Умная проекция на стол",
        desc: "Отображение важной информации и уведомлений прямо на поверхность стола"
      },
      feature4: {
        title: "mmWave радар",
        desc: "Мониторинг дыхания, сердцебиения и детекция падений без нарушения приватности"
      }
    },
    // Investors
    investors: {
      title: "Для инвесторов",
      subtitle: "Масштабируемая B2B/B2C модель в быстрорастущем рынке Silver Economy",
      stat1: {
        value: "$7.1 трлн",
        desc: "Размер глобального рынка Silver Economy к 2030 году"
      },
      stat2: {
        value: "25%+",
        desc: "Ежегодный рост рынка телемедицины"
      },
      stat3: {
        value: "SaaS",
        desc: "Рекуррентная модель доходов через премиум AI отчеты о здоровье"
      },
      stat4: {
        value: "B2B + B2C",
        desc: "Двойная модель: клиники + частные клиенты"
      }
    },
    // Testimonials
    testimonials: {
      title: "Отзывы",
      titleHighlight: "клиентов",
      review1: {
        name: "Елена Петрова",
        location: "Москва",
        text: "CAREVA дала мне спокойствие. Я знаю, что мама в безопасности, и при этом она не чувствует, что за ней постоянно наблюдают. Это идеальный баланс заботы и уважения."
      },
      review2: {
        name: "Андрей Смирнов",
        location: "Санкт-Петербург",
        text: "Установка заняла 5 минут. Встроенная 4G связь работает безупречно - даже когда у отца отключили интернет, устройство продолжало присылать уведомления."
      },
      review3: {
        name: "Мария Волкова",
        location: "Казань",
        text: "После падения бабушки устройство моментально отправило сигнал. Мы успели вызвать скорую вовремя. CAREVA буквально спасла ей жизнь."
      }
    },
    // FAQ
    faq: {
      title: "Часто задаваемые",
      titleHighlight: "вопросы",
      q1: {
        question: "Как работает технология mmWave радара?",
        answer: "mmWave радар использует высокочастотные радиоволны для обнаружения движения, дыхания и сердцебиения без необходимости в камерах или носимых датчиках. Технология полностью безопасна и не нарушает приватность."
      },
      q2: {
        question: "Нужен ли Wi-Fi для работы CAREVA?",
        answer: "Нет! CAREVA оснащена встроенным бесплатным 4G модулем, который работает независимо от домашнего интернета. Это обеспечивает стабильную связь даже при отключении Wi-Fi."
      },
      q3: {
        question: "Насколько сложна установка?",
        answer: "Установка занимает всего 5 минут. Просто подключите устройство к розетке, загрузите приложение и следуйте простым инструкциям. Никаких специальных знаний не требуется."
      },
      q4: {
        question: "Что происходит при отключении электричества?",
        answer: "CAREVA оснащена резервной батареей, которая обеспечивает работу до 48 часов без электричества. Встроенная 4G связь продолжает работать, гарантируя постоянную защиту."
      },
      q5: {
        question: "Какие данные собирает устройство?",
        answer: "CAREVA собирает только данные о дыхании, сердцебиении, движении и падениях. Никаких видео или аудио записей не ведется, обеспечивая 100% приватность."
      }
    },
    // Contact
    contact: {
      title: "Свяжитесь с нами",
      subtitle: "Готовы начать? Заполните форму, и мы свяжемся с вами в ближайшее время",
      nameLabel: "Имя",
      emailLabel: "Email",
      roleLabel: "Ваша роль",
      messageLabel: "Сообщение",
      namePlaceholder: "Введите ваше имя",
      emailPlaceholder: "your@email.com",
      messagePlaceholder: "Расскажите о ваших потребностях или интересах...",
      roleSelect: "Выберите роль",
      roleCustomer: "Покупатель",
      roleClinic: "Клиника",
      roleInvestor: "Инвестор",
      submit: "Отправить",
      successTitle: "Спасибо!",
      successMessage: "Ваше сообщение успешно отправлено. Мы свяжемся с вами в ближайшее время."
    },
    // Footer
    footer: {
      tagline: "Невидимая забота 24/7 для ваших близких с технологией mmWave радара",
      navigation: "Навигация",
      contactTitle: "Контакты",
      copyright: "© 2024 CAREVA. Все права защищены."
    }
  },
  en: {
    nav: {
      about: "About Product",
      features: "Features",
      investors: "For Investors",
      contact: "Contact",
      preorder: "Pre-order"
    },
    hero: {
      title: "Invisible CAREVA",
      titleHighlight: "24/7",
      subtitle: "CAREVA uses mmWave radar for discreet elderly monitoring without cameras. 100% privacy with built-in free 4G connectivity.",
      btnCustomers: "For Customers",
      btnInvestors: "For Investors"
    },
    comparison: {
      title: "Why",
      titleHighlight: "CAREVA",
      subtitle: "Compare our solution with traditional monitoring methods",
      cameras: {
        title: "Cameras",
        item1: "Invade privacy",
        item2: "Uncomfortable for elderly",
        item3: "Require Wi-Fi",
        item4: "Complex installation"
      },
      careva: {
        title: "CAREVA mmWave",
        item1: "100% privacy - no lenses",
        item2: "Invisible monitoring",
        item3: "Built-in 4G - independent of Wi-Fi",
        item4: "Simple installation"
      },
      wearables: {
        title: "Wearable Devices",
        item1: "Must wear constantly",
        item2: "Require charging",
        item3: "Easy to forget/lose",
        item4: "Uncomfortable during sleep"
      }
    },
    features: {
      title: "Technology",
      titleHighlight: "VitalGuard AI",
      feature1: {
        title: "Smart Night Light",
        desc: "Automatic lighting with motion sensors for safety during nighttime"
      },
      feature2: {
        title: "Backup Battery & SIM Slot",
        desc: "Works up to 48 hours without power with built-in 4G connectivity for emergencies"
      },
      feature3: {
        title: "Smart Table Projection",
        desc: "Display important information and notifications directly on table surface"
      },
      feature4: {
        title: "mmWave Radar",
        desc: "Monitor breathing, heartbeat, and fall detection without invading privacy"
      }
    },
    investors: {
      title: "For Investors",
      subtitle: "Scalable B2B/B2C model in the fast-growing Silver Economy market",
      stat1: {
        value: "$7.1 trillion",
        desc: "Global Silver Economy market size by 2030"
      },
      stat2: {
        value: "25%+",
        desc: "Annual telemedicine market growth"
      },
      stat3: {
        value: "SaaS",
        desc: "Recurring revenue model through premium AI health reports"
      },
      stat4: {
        value: "B2B + B2C",
        desc: "Dual model: clinics + private customers"
      }
    },
    testimonials: {
      title: "Customer",
      titleHighlight: "Reviews",
      review1: {
        name: "Elena Petrova",
        location: "Moscow",
        text: "CAREVA gave me peace of mind. I know my mother is safe, and she doesn't feel constantly watched. It's the perfect balance of care and respect."
      },
      review2: {
        name: "Andrey Smirnov",
        location: "Saint Petersburg",
        text: "Installation took 5 minutes. The built-in 4G works flawlessly - even when my father's internet was cut off, the device kept sending notifications."
      },
      review3: {
        name: "Maria Volkova",
        location: "Kazan",
        text: "After my grandmother's fall, the device instantly sent an alert. We called an ambulance in time. CAREVA literally saved her life."
      }
    },
    faq: {
      title: "Frequently Asked",
      titleHighlight: "Questions",
      q1: {
        question: "How does mmWave radar technology work?",
        answer: "mmWave radar uses high-frequency radio waves to detect movement, breathing, and heartbeat without cameras or wearable sensors. The technology is completely safe and doesn't invade privacy."
      },
      q2: {
        question: "Is Wi-Fi required for CAREVA to work?",
        answer: "No! CAREVA has a built-in free 4G module that works independently of home internet. This ensures stable connectivity even when Wi-Fi is down."
      },
      q3: {
        question: "How complicated is the installation?",
        answer: "Installation takes just 5 minutes. Simply plug the device into an outlet, download the app, and follow simple instructions. No special knowledge required."
      },
      q4: {
        question: "What happens during a power outage?",
        answer: "CAREVA has a backup battery that provides up to 48 hours of operation without electricity. Built-in 4G connectivity continues working, ensuring constant protection."
      },
      q5: {
        question: "What data does the device collect?",
        answer: "CAREVA only collects data on breathing, heartbeat, movement, and falls. No video or audio recordings are made, ensuring 100% privacy."
      }
    },
    contact: {
      title: "Contact Us",
      subtitle: "Ready to start? Fill out the form and we'll get back to you soon",
      nameLabel: "Name",
      emailLabel: "Email",
      roleLabel: "Your Role",
      messageLabel: "Message",
      namePlaceholder: "Enter your name",
      emailPlaceholder: "your@email.com",
      messagePlaceholder: "Tell us about your needs or interests...",
      roleSelect: "Select role",
      roleCustomer: "Customer",
      roleClinic: "Clinic",
      roleInvestor: "Investor",
      submit: "Submit",
      successTitle: "Thank You!",
      successMessage: "Your message has been sent successfully. We'll contact you soon."
    },
    footer: {
      tagline: "Invisible 24/7 care for your loved ones with mmWave radar technology",
      navigation: "Navigation",
      contactTitle: "Contact",
      copyright: "© 2024 CAREVA. All rights reserved."
    }
  },
  ro: {
    nav: {
      about: "Despre Produs",
      features: "Caracteristici",
      investors: "Pentru Investitori",
      contact: "Contact",
      preorder: "Precomandă"
    },
    hero: {
      title: "CAREVA Invizibilă",
      titleHighlight: "24/7",
      subtitle: "CAREVA folosește radar mmWave pentru monitorizarea discretă a persoanelor vârstnice fără camere. 100% confidențialitate cu conectivitate 4G gratuită integrată.",
      btnCustomers: "Pentru Clienți",
      btnInvestors: "Pentru Investitori"
    },
    comparison: {
      title: "De ce",
      titleHighlight: "CAREVA",
      subtitle: "Comparați soluția noastră cu metodele tradiționale de monitorizare",
      cameras: {
        title: "Camere Video",
        item1: "Invadează intimitatea",
        item2: "Incomod pentru vârstnici",
        item3: "Necesită Wi-Fi",
        item4: "Instalare complexă"
      },
      careva: {
        title: "CAREVA mmWave",
        item1: "100% intimitate - fără lentile",
        item2: "Monitorizare invizibilă",
        item3: "4G integrat - independent de Wi-Fi",
        item4: "Instalare simplă"
      },
      wearables: {
        title: "Dispozitive Purtabile",
        item1: "Trebuie purtat constant",
        item2: "Necesită încărcare",
        item3: "Ușor de uitat/pierdut",
        item4: "Incomod în timpul somnului"
      }
    },
    features: {
      title: "Tehnologie",
      titleHighlight: "VitalGuard AI",
      feature1: {
        title: "Lumină Nocturnă Inteligentă",
        desc: "Iluminare automată cu senzori de mișcare pentru siguranță în timpul nopții"
      },
      feature2: {
        title: "Baterie de Rezervă & Slot SIM",
        desc: "Funcționează până la 48 de ore fără curent cu conectivitate 4G integrată pentru urgențe"
      },
      feature3: {
        title: "Proiecție Inteligentă pe Masă",
        desc: "Afișează informații importante și notificări direct pe suprafața mesei"
      },
      feature4: {
        title: "Radar mmWave",
        desc: "Monitorizează respirația, bătăile inimii și detectează căderile fără a invada intimitatea"
      }
    },
    investors: {
      title: "Pentru Investitori",
      subtitle: "Model B2B/B2C scalabil pe piața în creștere rapidă Silver Economy",
      stat1: {
        value: "$7.1 trilioane",
        desc: "Dimensiunea pieței globale Silver Economy până în 2030"
      },
      stat2: {
        value: "25%+",
        desc: "Creștere anuală a pieței telemedicinei"
      },
      stat3: {
        value: "SaaS",
        desc: "Model de venit recurent prin rapoarte premium AI de sănătate"
      },
      stat4: {
        value: "B2B + B2C",
        desc: "Model dual: clinici + clienți privați"
      }
    },
    testimonials: {
      title: "Recenzii",
      titleHighlight: "clienți",
      review1: {
        name: "Elena Petrova",
        location: "Moscova",
        text: "CAREVA mi-a dat liniște sufletească. Știu că mama este în siguranță și nu simte că este constant supravegheată. Este echilibrul perfect între grijă și respect."
      },
      review2: {
        name: "Andrei Smirnov",
        location: "Sankt Petersburg",
        text: "Instalarea a durat 5 minute. 4G-ul integrat funcționează impecabil - chiar și când internetul tatălui meu a fost întrerupt, dispozitivul a continuat să trimită notificări."
      },
      review3: {
        name: "Maria Volkova",
        location: "Kazan",
        text: "După căderea bunicii mele, dispozitivul a trimis instant o alertă. Am sunat ambulanța la timp. CAREVA i-a salvat literalmente viața."
      }
    },
    faq: {
      title: "Întrebări",
      titleHighlight: "Frecvente",
      q1: {
        question: "Cum funcționează tehnologia radar mmWave?",
        answer: "Radarul mmWave folosește unde radio de înaltă frecvență pentru a detecta mișcarea, respirația și bătăile inimii fără camere sau senzori purtabili. Tehnologia este complet sigură și nu invadează intimitatea."
      },
      q2: {
        question: "Este necesar Wi-Fi pentru funcționarea CAREVA?",
        answer: "Nu! CAREVA are un modul 4G gratuit integrat care funcționează independent de internetul de acasă. Acest lucru asigură conectivitate stabilă chiar și când Wi-Fi-ul este oprit."
      },
      q3: {
        question: "Cât de complicată este instalarea?",
        answer: "Instalarea durează doar 5 minute. Pur și simplu conectați dispozitivul la priză, descărcați aplicația și urmați instrucțiunile simple. Nu sunt necesare cunoștințe speciale."
      },
      q4: {
        question: "Ce se întâmplă în timpul unei pene de curent?",
        answer: "CAREVA are o baterie de rezervă care oferă până la 48 de ore de funcționare fără electricitate. Conectivitatea 4G integrată continuă să funcționeze, asigurând protecție constantă."
      },
      q5: {
        question: "Ce date colectează dispozitivul?",
        answer: "CAREVA colectează doar date despre respirație, bătăi ale inimii, mișcare și căderi. Nu se fac înregistrări video sau audio, asigurând 100% confidențialitate."
      }
    },
    contact: {
      title: "Contactați-ne",
      subtitle: "Gata să începeți? Completați formularul și vă vom contacta în curând",
      nameLabel: "Nume",
      emailLabel: "Email",
      roleLabel: "Rolul Dvs.",
      messageLabel: "Mesaj",
      namePlaceholder: "Introduceți numele",
      emailPlaceholder: "email@dvs.com",
      messagePlaceholder: "Spuneți-ne despre nevoile sau interesele dvs...",
      roleSelect: "Selectați rolul",
      roleCustomer: "Client",
      roleClinic: "Clinică",
      roleInvestor: "Investitor",
      submit: "Trimite",
      successTitle: "Mulțumim!",
      successMessage: "Mesajul dvs. a fost trimis cu succes. Vă vom contacta în curând."
    },
    footer: {
      tagline: "Grijă invizibilă 24/7 pentru cei dragi cu tehnologie radar mmWave",
      navigation: "Navigare",
      contactTitle: "Contact",
      copyright: "© 2024 CAREVA. Toate drepturile rezervate."
    }
  },
  de: {
    nav: {
      about: "Über das Produkt",
      features: "Funktionen",
      investors: "Für Investoren",
      contact: "Kontakt",
      preorder: "Vorbestellen"
    },
    hero: {
      title: "Unsichtbare CAREVA",
      titleHighlight: "24/7",
      subtitle: "CAREVA nutzt mmWave-Radar zur diskreten Überwachung älterer Menschen ohne Kameras. 100% Privatsphäre mit integrierter kostenloser 4G-Verbindung.",
      btnCustomers: "Für Kunden",
      btnInvestors: "Für Investoren"
    },
    comparison: {
      title: "Warum",
      titleHighlight: "CAREVA",
      subtitle: "Vergleichen Sie unsere Lösung mit traditionellen Überwachungsmethoden",
      cameras: {
        title: "Kameras",
        item1: "Verletzen Privatsphäre",
        item2: "Unbequem für Senioren",
        item3: "Benötigen Wi-Fi",
        item4: "Komplexe Installation"
      },
      careva: {
        title: "CAREVA mmWave",
        item1: "100% Privatsphäre - keine Linsen",
        item2: "Unsichtbare Überwachung",
        item3: "Integriertes 4G - unabhängig von Wi-Fi",
        item4: "Einfache Installation"
      },
      wearables: {
        title: "Tragbare Geräte",
        item1: "Muss ständig getragen werden",
        item2: "Benötigen Aufladung",
        item3: "Leicht zu vergessen/verlieren",
        item4: "Unbequem beim Schlafen"
      }
    },
    features: {
      title: "Technologie",
      titleHighlight: "VitalGuard AI",
      feature1: {
        title: "Intelligentes Nachtlicht",
        desc: "Automatische Beleuchtung mit Bewegungssensoren für Sicherheit in der Nacht"
      },
      feature2: {
        title: "Backup-Batterie & SIM-Slot",
        desc: "Funktioniert bis zu 48 Stunden ohne Strom mit integrierter 4G-Verbindung für Notfälle"
      },
      feature3: {
        title: "Intelligente Tischprojektion",
        desc: "Zeigt wichtige Informationen und Benachrichtigungen direkt auf der Tischoberfläche an"
      },
      feature4: {
        title: "mmWave Radar",
        desc: "Überwacht Atmung, Herzschlag und Sturzerkennung ohne Verletzung der Privatsphäre"
      }
    },
    investors: {
      title: "Für Investoren",
      subtitle: "Skalierbares B2B/B2C-Modell im schnell wachsenden Silver Economy Markt",
      stat1: {
        value: "$7,1 Billionen",
        desc: "Globale Silver Economy Marktgröße bis 2030"
      },
      stat2: {
        value: "25%+",
        desc: "Jährliches Wachstum des Telemedizin-Marktes"
      },
      stat3: {
        value: "SaaS",
        desc: "Wiederkehrendes Umsatzmodell durch Premium-KI-Gesundheitsberichte"
      },
      stat4: {
        value: "B2B + B2C",
        desc: "Duales Modell: Kliniken + Privatkunden"
      }
    },
    testimonials: {
      title: "Kunden",
      titleHighlight: "bewertungen",
      review1: {
        name: "Elena Petrova",
        location: "Moskau",
        text: "CAREVA hat mir Seelenfrieden gegeben. Ich weiß, dass meine Mutter sicher ist und sie fühlt sich nicht ständig beobachtet. Es ist die perfekte Balance zwischen Fürsorge und Respekt."
      },
      review2: {
        name: "Andrey Smirnov",
        location: "Sankt Petersburg",
        text: "Die Installation dauerte 5 Minuten. Das integrierte 4G funktioniert einwandfrei - selbst als das Internet meines Vaters ausgefallen war, sendete das Gerät weiterhin Benachrichtigungen."
      },
      review3: {
        name: "Maria Volkova",
        location: "Kasan",
        text: "Nach dem Sturz meiner Großmutter sendete das Gerät sofort eine Warnung. Wir konnten rechtzeitig einen Krankenwagen rufen. CAREVA hat ihr buchstäblich das Leben gerettet."
      }
    },
    faq: {
      title: "Häufig gestellte",
      titleHighlight: "Fragen",
      q1: {
        question: "Wie funktioniert die mmWave-Radar-Technologie?",
        answer: "mmWave-Radar verwendet hochfrequente Radiowellen zur Erkennung von Bewegung, Atmung und Herzschlag ohne Kameras oder tragbare Sensoren. Die Technologie ist völlig sicher und verletzt nicht die Privatsphäre."
      },
      q2: {
        question: "Ist Wi-Fi für den Betrieb von CAREVA erforderlich?",
        answer: "Nein! CAREVA hat ein integriertes kostenloses 4G-Modul, das unabhängig vom heimischen Internet funktioniert. Dies gewährleistet stabile Konnektivität auch bei Wi-Fi-Ausfall."
      },
      q3: {
        question: "Wie kompliziert ist die Installation?",
        answer: "Die Installation dauert nur 5 Minuten. Stecken Sie einfach das Gerät in eine Steckdose, laden Sie die App herunter und folgen Sie den einfachen Anweisungen. Keine speziellen Kenntnisse erforderlich."
      },
      q4: {
        question: "Was passiert bei einem Stromausfall?",
        answer: "CAREVA verfügt über eine Backup-Batterie, die bis zu 48 Stunden Betrieb ohne Strom ermöglicht. Die integrierte 4G-Verbindung funktioniert weiter und gewährleistet ständigen Schutz."
      },
      q5: {
        question: "Welche Daten sammelt das Gerät?",
        answer: "CAREVA sammelt nur Daten über Atmung, Herzschlag, Bewegung und Stürze. Es werden keine Video- oder Audioaufnahmen gemacht, was 100% Privatsphäre gewährleistet."
      }
    },
    contact: {
      title: "Kontaktieren Sie uns",
      subtitle: "Bereit anzufangen? Füllen Sie das Formular aus und wir melden uns bald",
      nameLabel: "Name",
      emailLabel: "E-Mail",
      roleLabel: "Ihre Rolle",
      messageLabel: "Nachricht",
      namePlaceholder: "Geben Sie Ihren Namen ein",
      emailPlaceholder: "ihre@email.com",
      messagePlaceholder: "Erzählen Sie uns von Ihren Bedürfnissen oder Interessen...",
      roleSelect: "Rolle wählen",
      roleCustomer: "Kunde",
      roleClinic: "Klinik",
      roleInvestor: "Investor",
      submit: "Senden",
      successTitle: "Vielen Dank!",
      successMessage: "Ihre Nachricht wurde erfolgreich gesendet. Wir melden uns bald bei Ihnen."
    },
    footer: {
      tagline: "Unsichtbare 24/7 Pflege für Ihre Lieben mit mmWave-Radar-Technologie",
      navigation: "Navigation",
      contactTitle: "Kontakt",
      copyright: "© 2024 CAREVA. Alle Rechte vorbehalten."
    }
  },
  ja: {
    nav: {
      about: "製品について",
      features: "機能",
      investors: "投資家向け",
      contact: "お問い合わせ",
      preorder: "予約注文"
    },
    hero: {
      title: "見えないCAREVA",
      titleHighlight: "24時間365日",
      subtitle: "CAREVAは、カメラなしで高齢者を目立たず監視するためのmmWaveレーダーを使用しています。無料の4G接続内蔵で100%プライバシー保護。",
      btnCustomers: "お客様向け",
      btnInvestors: "投資家向け"
    },
    comparison: {
      title: "なぜ",
      titleHighlight: "CAREVA",
      subtitle: "当社のソリューションと従来の監視方法を比較",
      cameras: {
        title: "カメラ",
        item1: "プライバシーを侵害",
        item2: "高齢者にとって不快",
        item3: "Wi-Fiが必要",
        item4: "複雑な設置"
      },
      careva: {
        title: "CAREVA mmWave",
        item1: "100%プライバシー - レンズなし",
        item2: "見えない監視",
        item3: "4G内蔵 - Wi-Fi不要",
        item4: "簡単な設置"
      },
      wearables: {
        title: "ウェアラブルデバイス",
        item1: "常に装着が必要",
        item2: "充電が必要",
        item3: "忘れたり紛失しやすい",
        item4: "睡眠中は不快"
      }
    },
    features: {
      title: "テクノロジー",
      titleHighlight: "VitalGuard AI",
      feature1: {
        title: "スマートナイトライト",
        desc: "夜間の安全のためのモーションセンサー付き自動照明"
      },
      feature2: {
        title: "予備バッテリー＆SIMスロット",
        desc: "緊急時のために4G接続内蔵で電源なしで最大48時間動作"
      },
      feature3: {
        title: "スマートテーブルプロジェクション",
        desc: "重要な情報や通知をテーブル表面に直接表示"
      },
      feature4: {
        title: "mmWaveレーダー",
        desc: "プライバシーを侵害することなく呼吸、心拍、転倒検出を監視"
      }
    },
    investors: {
      title: "投資家向け",
      subtitle: "急成長するシルバーエコノミー市場でのスケーラブルなB2B/B2Cモデル",
      stat1: {
        value: "7.1兆ドル",
        desc: "2030年までのグローバルシルバーエコノミー市場規模"
      },
      stat2: {
        value: "25%以上",
        desc: "遠隔医療市場の年間成長率"
      },
      stat3: {
        value: "SaaS",
        desc: "プレミアムAIヘルスレポートによる継続的収益モデル"
      },
      stat4: {
        value: "B2B + B2C",
        desc: "デュアルモデル：クリニック＋個人顧客"
      }
    },
    testimonials: {
      title: "お客様の",
      titleHighlight: "声",
      review1: {
        name: "エレナ・ペトロワ",
        location: "モスクワ",
        text: "CAREVAは私に安心を与えてくれました。母が安全であることがわかり、母も常に監視されていると感じることはありません。ケアと尊重の完璧なバランスです。"
      },
      review2: {
        name: "アンドレイ・スミルノフ",
        location: "サンクトペテルブルク",
        text: "設置は5分で完了しました。内蔵4Gは完璧に機能します - 父のインターネットが切断されても、デバイスは通知を送り続けました。"
      },
      review3: {
        name: "マリア・ヴォルコワ",
        location: "カザン",
        text: "祖母が転倒した後、デバイスは即座に警告を送信しました。時間内に救急車を呼ぶことができました。CAREVAは文字通り彼女の命を救いました。"
      }
    },
    faq: {
      title: "よくある",
      titleHighlight: "質問",
      q1: {
        question: "mmWaveレーダー技術はどのように機能しますか？",
        answer: "mmWaveレーダーは、カメラやウェアラブルセンサーなしで動き、呼吸、心拍を検出するために高周波無線波を使用します。この技術は完全に安全で、プライバシーを侵害しません。"
      },
      q2: {
        question: "CAREVAの動作にWi-Fiは必要ですか？",
        answer: "いいえ！CAREVAには、家庭のインターネットとは独立して機能する無料の4Gモジュールが内蔵されています。これにより、Wi-Fiがダウンしても安定した接続が確保されます。"
      },
      q3: {
        question: "設置はどのくらい複雑ですか？",
        answer: "設置はわずか5分です。デバイスをコンセントに差し込み、アプリをダウンロードして、簡単な指示に従うだけです。特別な知識は必要ありません。"
      },
      q4: {
        question: "停電時はどうなりますか？",
        answer: "CAREVAには予備バッテリーがあり、電気なしで最大48時間の動作を提供します。内蔵4G接続は動作し続け、常に保護を保証します。"
      },
      q5: {
        question: "デバイスはどのようなデータを収集しますか？",
        answer: "CAREVAは呼吸、心拍、動き、転倒に関するデータのみを収集します。ビデオやオーディオの記録は行われず、100%のプライバシーが確保されます。"
      }
    },
    contact: {
      title: "お問い合わせ",
      subtitle: "始める準備はできましたか？フォームに記入していただければ、すぐにご連絡いたします",
      nameLabel: "お名前",
      emailLabel: "メールアドレス",
      roleLabel: "役割",
      messageLabel: "メッセージ",
      namePlaceholder: "お名前を入力してください",
      emailPlaceholder: "your@email.com",
      messagePlaceholder: "ご要望や興味についてお聞かせください...",
      roleSelect: "役割を選択",
      roleCustomer: "お客様",
      roleClinic: "クリニック",
      roleInvestor: "投資家",
      submit: "送信",
      successTitle: "ありがとうございます！",
      successMessage: "メッセージが正常に送信されました。すぐにご連絡いたします。"
    },
    footer: {
      tagline: "mmWaveレーダー技術による大切な人への見えない24時間365日のケア",
      navigation: "ナビゲーション",
      contactTitle: "お問い合わせ",
      copyright: "© 2024 CAREVA. 全著作権所有。"
    }
  },
  ar: {
    nav: {
      about: "حول المنتج",
      features: "المميزات",
      investors: "للمستثمرين",
      contact: "اتصل بنا",
      preorder: "الطلب المسبق"
    },
    hero: {
      title: "CAREVA غير مرئية",
      titleHighlight: "24/7",
      subtitle: "تستخدم CAREVA رادار mmWave لمراقبة كبار السن بشكل سري دون كاميرات. خصوصية 100٪ مع اتصال 4G مجاني مدمج.",
      btnCustomers: "للعملاء",
      btnInvestors: "للمستثمرين"
    },
    comparison: {
      title: "لماذا",
      titleHighlight: "CAREVA",
      subtitle: "قارن حلنا مع طرق المراقبة التقليدية",
      cameras: {
        title: "الكاميرات",
        item1: "تنتهك الخصوصية",
        item2: "غير مريحة لكبار السن",
        item3: "تتطلب Wi-Fi",
        item4: "تركيب معقد"
      },
      careva: {
        title: "CAREVA mmWave",
        item1: "خصوصية 100٪ - بدون عدسات",
        item2: "مراقبة غير مرئية",
        item3: "4G مدمج - مستقل عن Wi-Fi",
        item4: "تركيب بسيط"
      },
      wearables: {
        title: "الأجهزة القابلة للارتداء",
        item1: "يجب ارتداؤها باستمرار",
        item2: "تتطلب الشحن",
        item3: "سهلة النسيان/الفقدان",
        item4: "غير مريحة أثناء النوم"
      }
    },
    features: {
      title: "تقنية",
      titleHighlight: "VitalGuard AI",
      feature1: {
        title: "ضوء ليلي ذكي",
        desc: "إضاءة تلقائية مع أجهزة استشعار الحركة للسلامة أثناء الليل"
      },
      feature2: {
        title: "بطارية احتياطية وفتحة SIM",
        desc: "يعمل حتى 48 ساعة بدون كهرباء مع اتصال 4G مدمج للطوارئ"
      },
      feature3: {
        title: "إسقاط ذكي على الطاولة",
        desc: "عرض المعلومات المهمة والإشعارات مباشرة على سطح الطاولة"
      },
      feature4: {
        title: "رادار mmWave",
        desc: "مراقبة التنفس ونبضات القلب واكتشاف السقوط دون انتهاك الخصوصية"
      }
    },
    investors: {
      title: "للمستثمرين",
      subtitle: "نموذج B2B/B2C قابل للتطوير في سوق الاقتصاد الفضي سريع النمو",
      stat1: {
        value: "7.1 تريليون دولار",
        desc: "حجم سوق الاقتصاد الفضي العالمي بحلول 2030"
      },
      stat2: {
        value: "+25٪",
        desc: "النمو السنوي لسوق الطب عن بعد"
      },
      stat3: {
        value: "SaaS",
        desc: "نموذج إيرادات متكررة من خلال تقارير صحية متميزة بالذكاء الاصطناعي"
      },
      stat4: {
        value: "B2B + B2C",
        desc: "نموذج مزدوج: العيادات + العملاء الخاصون"
      }
    },
    testimonials: {
      title: "آراء",
      titleHighlight: "العملاء",
      review1: {
        name: "إيلينا بتروفا",
        location: "موسكو",
        text: "أعطتني CAREVA راحة البال. أعلم أن والدتي آمنة ولا تشعر بأنها تحت المراقبة المستمرة. إنه التوازن المثالي بين الرعاية والاحترام."
      },
      review2: {
        name: "أندريه سميرنوف",
        location: "سانت بطرسبرغ",
        text: "استغرق التثبيت 5 دقائق. يعمل 4G المدمج بشكل لا تشوبه شائبة - حتى عندما تم قطع إنترنت والدي، استمر الجهاز في إرسال الإشعارات."
      },
      review3: {
        name: "ماريا فولكوفا",
        location: "قازان",
        text: "بعد سقوط جدتي، أرسل الجهاز تنبيهاً فورياً. تمكنا من استدعاء الإسعاف في الوقت المناسب. أنقذت CAREVA حياتها حرفياً."
      }
    },
    faq: {
      title: "الأسئلة",
      titleHighlight: "الشائعة",
      q1: {
        question: "كيف تعمل تقنية رادار mmWave؟",
        answer: "يستخدم رادار mmWave موجات راديو عالية التردد للكشف عن الحركة والتنفس ونبضات القلب دون الحاجة إلى كاميرات أو أجهزة استشعار يمكن ارتداؤها. التقنية آمنة تماماً ولا تنتهك الخصوصية."
      },
      q2: {
        question: "هل يتطلب CAREVA Wi-Fi للعمل؟",
        answer: "لا! لدى CAREVA وحدة 4G مجانية مدمجة تعمل بشكل مستقل عن الإنترنت المنزلي. هذا يضمن اتصالاً مستقراً حتى عند انقطاع Wi-Fi."
      },
      q3: {
        question: "ما مدى تعقيد التثبيت؟",
        answer: "يستغرق التثبيت 5 دقائق فقط. ما عليك سوى توصيل الجهاز بمأخذ كهربائي، وتنزيل التطبيق، واتباع التعليمات البسيطة. لا حاجة لمعرفة خاصة."
      },
      q4: {
        question: "ماذا يحدث أثناء انقطاع التيار الكهربائي؟",
        answer: "لدى CAREVA بطارية احتياطية توفر ما يصل إلى 48 ساعة من التشغيل بدون كهرباء. يستمر اتصال 4G المدمج في العمل، مما يضمن الحماية المستمرة."
      },
      q5: {
        question: "ما البيانات التي يجمعها الجهاز؟",
        answer: "تجمع CAREVA فقط البيانات المتعلقة بالتنفس ونبضات القلب والحركة والسقوط. لا يتم إجراء أي تسجيلات فيديو أو صوتية، مما يضمن خصوصية 100٪."
      }
    },
    contact: {
      title: "اتصل بنا",
      subtitle: "مستعد للبدء؟ املأ النموذج وسنتواصل معك قريباً",
      nameLabel: "الاسم",
      emailLabel: "البريد الإلكتروني",
      roleLabel: "دورك",
      messageLabel: "رسالة",
      namePlaceholder: "أدخل اسمك",
      emailPlaceholder: "your@email.com",
      messagePlaceholder: "أخبرنا عن احتياجاتك أو اهتماماتك...",
      roleSelect: "اختر الدور",
      roleCustomer: "عميل",
      roleClinic: "عيادة",
      roleInvestor: "مستثمر",
      submit: "إرسال",
      successTitle: "شكراً لك!",
      successMessage: "تم إرسال رسالتك بنجاح. سنتواصل معك قريباً."
    },
    footer: {
      tagline: "رعاية غير مرئية على مدار الساعة طوال أيام الأسبوع لأحبائك بتقنية رادار mmWave",
      navigation: "التنقل",
      contactTitle: "اتصل بنا",
      copyright: "© 2024 CAREVA. جميع الحقوق محفوظة."
    }
  },
  zh: {
    nav: {
      about: "关于产品",
      features: "功能特点",
      investors: "投资者",
      contact: "联系我们",
      preorder: "预订"
    },
    hero: {
      title: "隐形关怀",
      titleHighlight: "全天候",
      subtitle: "CAREVA使用毫米波雷达技术在无摄像头的情况下谨慎监测老年人。内置免费4G连接，100%保护隐私。",
      btnCustomers: "客户专区",
      btnInvestors: "投资者专区"
    },
    comparison: {
      title: "为什么选择",
      titleHighlight: "CAREVA",
      subtitle: "将我们的解决方案与传统监测方法进行比较",
      cameras: {
        title: "摄像头",
        item1: "侵犯隐私",
        item2: "老年人不适",
        item3: "需要Wi-Fi",
        item4: "安装复杂"
      },
      careva: {
        title: "CAREVA毫米波",
        item1: "100%隐私 - 无镜头",
        item2: "隐形监测",
        item3: "内置4G - 不依赖Wi-Fi",
        item4: "简单安装"
      },
      wearables: {
        title: "可穿戴设备",
        item1: "必须持续佩戴",
        item2: "需要充电",
        item3: "容易忘记/丢失",
        item4: "睡眠时不舒适"
      }
    },
    features: {
      title: "技术",
      titleHighlight: "VitalGuard AI",
      feature1: {
        title: "智能夜灯",
        desc: "配有运动传感器的自动照明，确保夜间安全"
      },
      feature2: {
        title: "备用电池和SIM卡槽",
        desc: "无电源情况下可工作48小时，内置4G连接用于紧急情况"
      },
      feature3: {
        title: "智能桌面投影",
        desc: "直接在桌面上显示重要信息和通知"
      },
      feature4: {
        title: "毫米波雷达",
        desc: "在不侵犯隐私的情况下监测呼吸、心跳和跌倒检测"
      }
    },
    investors: {
      title: "投资者专区",
      subtitle: "快速增长的银发经济市场中可扩展的B2B/B2C模式",
      stat1: {
        value: "7.1万亿美元",
        desc: "2030年全球银发经济市场规模"
      },
      stat2: {
        value: "25%+",
        desc: "远程医疗市场年增长率"
      },
      stat3: {
        value: "SaaS",
        desc: "通过高级AI健康报告的经常性收入模式"
      },
      stat4: {
        value: "B2B + B2C",
        desc: "双重模式：诊所+私人客户"
      }
    },
    testimonials: {
      title: "客户",
      titleHighlight: "评价",
      review1: {
        name: "埃琳娜·彼得罗娃",
        location: "莫斯科",
        text: "CAREVA让我安心。我知道妈妈很安全，她也不会觉得被持续监视。这是关怀与尊重的完美平衡。"
      },
      review2: {
        name: "安德烈·斯米尔诺夫",
        location: "圣彼得堡",
        text: "安装只用了5分钟。内置4G工作完美 - 即使父亲的网络中断，设备仍继续发送通知。"
      },
      review3: {
        name: "玛丽亚·沃尔科娃",
        location: "喀山",
        text: "祖母跌倒后，设备立即发出警报。我们及时叫了救护车。CAREVA确实救了她的命。"
      }
    },
    faq: {
      title: "常见",
      titleHighlight: "问题",
      q1: {
        question: "毫米波雷达技术如何工作？",
        answer: "毫米波雷达使用高频无线电波检测运动、呼吸和心跳，无需摄像头或可穿戴传感器。该技术完全安全，不侵犯隐私。"
      },
      q2: {
        question: "CAREVA需要Wi-Fi才能工作吗？",
        answer: "不需要！CAREVA配有内置免费4G模块，独立于家庭互联网工作。即使Wi-Fi断开也能确保稳定连接。"
      },
      q3: {
        question: "安装有多复杂？",
        answer: "安装只需5分钟。只需将设备插入插座，下载应用程序并遵循简单说明。无需特殊知识。"
      },
      q4: {
        question: "停电时会发生什么？",
        answer: "CAREVA配有备用电池，可在无电源情况下提供长达48小时的运行。内置4G连接继续工作，确保持续保护。"
      },
      q5: {
        question: "设备收集哪些数据？",
        answer: "CAREVA仅收集有关呼吸、心跳、运动和跌倒的数据。不进行任何视频或音频记录，确保100%隐私。"
      }
    },
    contact: {
      title: "联系我们",
      subtitle: "准备开始了吗？填写表格，我们会尽快与您联系",
      nameLabel: "姓名",
      emailLabel: "电子邮件",
      roleLabel: "您的角色",
      messageLabel: "留言",
      namePlaceholder: "输入您的姓名",
      emailPlaceholder: "your@email.com",
      messagePlaceholder: "告诉我们您的需求或兴趣...",
      roleSelect: "选择角色",
      roleCustomer: "客户",
      roleClinic: "诊所",
      roleInvestor: "投资者",
      submit: "提交",
      successTitle: "谢谢！",
      successMessage: "您的消息已成功发送。我们会尽快与您联系。"
    },
    footer: {
      tagline: "采用毫米波雷达技术为您的亲人提供全天候隐形关怀",
      navigation: "导航",
      contactTitle: "联系方式",
      copyright: "© 2024 CAREVA. 版权所有。"
    }
  }
};
